module.exports = __webpack_public_path__ + "static-portal/img/icon-06.a702280.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-06.png
// module id = gba0
// module chunks = 4